import React from 'react';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import { CheckCircle, ArrowRight, Layers, Palette, Clock } from 'lucide-react';
export function ScreenPrintingPage() {
  return <div className="min-h-screen bg-white flex flex-col" data-id="element-663">
      <Header data-id="element-664" />

      <main className="flex-grow" data-id="element-665">
        {/* Hero */}
        <section className="bg-gradient-to-r from-blue-600 to-purple-600 text-white py-20 md:py-28" data-id="element-666">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex flex-col md:flex-row items-center gap-12" data-id="element-667">
            <div className="md:w-1/2" data-id="element-668">
              <h1 className="text-4xl md:text-5xl font-bold mb-6 leading-tight" data-id="element-669">
                Premium Screen Printing for Bulk Orders
              </h1>
              <p className="text-xl text-blue-100 mb-8 leading-relaxed" data-id="element-670">
                The industry standard for durable, vibrant, and cost-effective
                custom apparel. Perfect for teams, events, businesses, and
                organizations needing 12+ items.
              </p>
              <a href="/contact" className="inline-flex items-center px-8 py-4 bg-white text-purple-600 font-bold rounded-full shadow-lg hover:bg-gray-50 transition-all transform hover:-translate-y-1" data-id="element-671">
                Get a Quote
                <ArrowRight className="ml-2 h-5 w-5" data-id="element-672" />
              </a>
            </div>
            <div className="md:w-1/2" data-id="element-673">
              <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-8 border border-white/20" data-id="element-674">
                <div className="space-y-4" data-id="element-675">
                  <div className="flex items-center space-x-3" data-id="element-676">
                    <CheckCircle className="h-6 w-6 text-teal-300" data-id="element-677" />
                    <span className="text-lg" data-id="element-678">Best value for bulk orders</span>
                  </div>
                  <div className="flex items-center space-x-3" data-id="element-679">
                    <CheckCircle className="h-6 w-6 text-teal-300" data-id="element-680" />
                    <span className="text-lg" data-id="element-681">
                      Long-lasting, durable prints
                    </span>
                  </div>
                  <div className="flex items-center space-x-3" data-id="element-682">
                    <CheckCircle className="h-6 w-6 text-teal-300" data-id="element-683" />
                    <span className="text-lg" data-id="element-684">
                      Vibrant, exact color matching
                    </span>
                  </div>
                  <div className="flex items-center space-x-3" data-id="element-685">
                    <CheckCircle className="h-6 w-6 text-teal-300" data-id="element-686" />
                    <span className="text-lg" data-id="element-687">Works on almost any fabric</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Process Steps */}
        <section className="py-20" data-id="element-688">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-689">
            <div className="text-center mb-16" data-id="element-690">
              <h2 className="text-3xl font-bold text-gray-900 mb-4" data-id="element-691">
                How It Works
              </h2>
              <p className="text-gray-600 max-w-2xl mx-auto" data-id="element-692">
                Our screen printing process ensures quality and consistency for
                every single item in your order.
              </p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-693">
              <div className="text-center p-6" data-id="element-694">
                <div className="w-16 h-16 bg-purple-100 rounded-full flex items-center justify-center mx-auto mb-6" data-id="element-695">
                  <Palette className="h-8 w-8 text-purple-600" data-id="element-696" />
                </div>
                <h3 className="text-xl font-bold mb-3" data-id="element-697">1. Design Prep</h3>
                <p className="text-gray-600" data-id="element-698">
                  We separate your artwork into individual colors and create
                  custom screens for each layer of the design.
                </p>
              </div>
              <div className="text-center p-6" data-id="element-699">
                <div className="w-16 h-16 bg-teal-100 rounded-full flex items-center justify-center mx-auto mb-6" data-id="element-700">
                  <Layers className="h-8 w-8 text-teal-600" data-id="element-701" />
                </div>
                <h3 className="text-xl font-bold mb-3" data-id="element-702">2. Printing</h3>
                <p className="text-gray-600" data-id="element-703">
                  Ink is pushed through the screens directly onto the fabric,
                  layering colors to build the final image.
                </p>
              </div>
              <div className="text-center p-6" data-id="element-704">
                <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-6" data-id="element-705">
                  <Clock className="h-8 w-8 text-blue-600" data-id="element-706" />
                </div>
                <h3 className="text-xl font-bold mb-3" data-id="element-707">3. Curing</h3>
                <p className="text-gray-600" data-id="element-708">
                  Garments pass through a high-heat dryer to cure the ink,
                  ensuring the print lasts for years.
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* CTA */}
        <section className="bg-gray-50 py-20" data-id="element-709">
          <div className="max-w-4xl mx-auto px-4 text-center" data-id="element-710">
            <h2 className="text-3xl font-bold text-gray-900 mb-6" data-id="element-711">
              Ready to get started?
            </h2>
            <p className="text-lg text-gray-600 mb-8" data-id="element-712">
              Contact us today for a free quote on your screen printing project.
              We offer competitive pricing and quick turnaround times.
            </p>
            <a href="/contact" className="inline-flex items-center px-8 py-4 bg-purple-600 hover:bg-purple-700 text-white font-bold rounded-full shadow-lg hover:shadow-xl transition-all" data-id="element-713">
              Contact Us
            </a>
          </div>
        </section>
      </main>

      <Footer data-id="element-714" />
    </div>;
}